export const NO_SUPPLIER_ID = 'no-supplier'
export const NO_SUPPLIER_LABEL = 'Sin proveedor'
